<template>
  <tag-data-table :table-data="tableData"></tag-data-table>
</template>

<script>
import { CriticalEvent } from '@/models/map/CriticalEvent'
import TagDataTable from '@/components/map/criticalPopup/tagDataTable'

export default {
  name: 'criticalSettings',
  components: { TagDataTable },
  props: {
    event: CriticalEvent
  },
  computed: {
    tableData () {
      const settings = this.event.settings.backendModel()
      const fields = Object.keys(settings)
      const result = []

      for (const field of fields) {
        result.push({
          field,
          value: settings[field]
        })
      }

      return result
    }
  }
}
</script>

<style scoped>

</style>
